import {inject, Injectable, isDevMode}             from '@angular/core';
import {getDownloadURL, ref, Storage}              from '@angular/fire/storage';
import {TwColorType, TwColorUnionType, TwTintType} from '@djsharkk/logr-types';
import {formatHex, parse}                          from 'culori';
import colors                                      from 'tailwindcss/colors';
import tinyColor                                   from 'tinycolor2';

@Injectable({
				providedIn: 'root'
			})
export class UiThemeService {
	bgVideoUrl: string = '';
	rootStyles = getComputedStyle(document.documentElement);

	constructor() {
		if (!isDevMode()) {
			this.backgroundVideo().then((url) => (this.bgVideoUrl = url));
		}
	}

	getTailwindColor = (code: TwColorType, tint: TwTintType, a = 1): string => tinyColor(formatHex(parse(colors[code][tint])) || '#ff00ff').setAlpha(a).toRgbString()

	getComputedColor(code: TwColorUnionType, tint?: TwTintType, a = 1): string {
		const cssVar = `--color-${code}${tint ? `-${tint}` : ''}`;
		let colorValue = this.rootStyles?.getPropertyValue(cssVar).trim();

		if (!colorValue) {
			// Wait for the next tick before trying again
			setTimeout(() => {
				colorValue = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
			}, 0);
		}

		return tinyColor(colorValue || '#000000').setAlpha(a).toRgbString();
	}

	backgroundVideo(): Promise<string> {
		const storage: Storage = inject(Storage);
		return new Promise((resolve, reject) => {

			const gsReference = ref(storage, 'gs://logr-pwa-2024.appspot.com/bg-02.mov');
			getDownloadURL(gsReference)
				.then((url) => {
					resolve(url);
				})
				.catch((error) => {
					console.log(error);
					reject(error);
				});
		});
	}

}
